import { render } from "./TradesModal.vue?vue&type=template&id=62930fc0"
import script from "./TradesModal.vue?vue&type=script&lang=js"
export * from "./TradesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__